import React, {useState} from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import ReactDOM from 'react-dom';
import configData from "../config/config.json";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import '../Login.css';
import CircularProgress from '@mui/material/CircularProgress';

export default function Login(props) {

    const [username, setUsername] = React.useState('');
    const [waitingMessage, setwaitingMessage] = React.useState(false);

    const handleChangeUser = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value);
    };

    const [password, setPassword] = React.useState('');

    const handleChangePass = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const loginCheck = () => {

            setwaitingMessage(true)
  
          const dataLogin = { "username": username, "password": password };
  
          const reqLogin = async () => {

            const responseData = await axios.post('https://ro-api.dashboard.vip-intercars.bg/checklogin', dataLogin, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest' //the token is a variable which holds the token
                }}).then((results) => {

                    if(results.data.length > 0 && results.status == 200){
                            sessionStorage.setItem('tokenDashboard', results.data);
                            
                            ReactDOM.render(<Alert severity="success">
                                <AlertTitle>Successfully logged in! You will be redirected after 2 seconds!</AlertTitle>
                            </Alert>, document.getElementById('message-status'));
                            setwaitingMessage(false)
                            
                            setTimeout(function(){
                            window.location.reload(true);
                        }, 2000);
                    } else if(results.data.status == 401) {
                        setwaitingMessage(false)
                        ReactDOM.render(<Alert severity="error">
                    <AlertTitle>Wrong username or password!</AlertTitle>
                    </Alert>, document.getElementById('message-status'));
                    }
                }).catch(error => {console.log(error);
                    setwaitingMessage(false)
                    ReactDOM.render(<Alert severity="error">
                    <AlertTitle>{error.message}</AlertTitle>
                    </Alert>, document.getElementById('message-status'));
                })

           }

           reqLogin()

    };

    if(waitingMessage){
        ReactDOM.render(
        <CircularProgress />
        , document.getElementById('message-status'))
    }


    return (
        <>
        <div className="Login">
        <div id="logo-login-form"><img id="logo-login-form-img" src="https://bg.marketplace.intercars.eu/media/logo/default/logo_Marketplace.jpg"></img></div>
        <div id="message-status"></div>
        <div id="login-username">
              <TextField
                id="outlined-required"
                label="Username"
                value={username}
                onChange={handleChangeUser}
              /></div>
        <div id="login-password">    
            <TextField
                id="outlined-password-input"
                label="Password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={handleChangePass}
                /></div>

        <div id="login-submit">
              <Button size="small" variant="outlined" onClick={() => loginCheck()}>
              Login
            </Button>
        </div>
        </div>
        </>
    )

}